import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, User, LogIn } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { useIsMobile } from '@/hooks/use-mobile';
const DesktopHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    user
  } = useAuth();
  const isMobile = useIsMobile();

  // Only show on desktop devices
  if (isMobile) return null;

  // Don't show on home page
  if (location.pathname === '/') return null;
  return;
};
export default DesktopHeader;